import AboutMissionSection from "./AboutMissionSection";
import AboutMethodSection from "./AboutMethodSection";
import AboutTeamSection from "./AboutTeamSection";
import AboutContactSection from "./AboutContactSection";

export default function AboutContent({selectedTab, setSelectedTab}) {
    // Used in AboutScreen to display content in desktop / tablet mode

    // BUILD
    return (
        <div className={"hidden sm:block animate-appear bg-backgroundLight3 w-full grow"}>
            {_renderSelectedTab()}
        </div>
    );

    // ---- Render selected tab content
    function _renderSelectedTab() {
        switch (selectedTab) {
            case (0):
                return <AboutMissionSection goToMethod={() => setSelectedTab(1)} />
            case (1):
                return <AboutMethodSection />
            case (2):
                return <AboutTeamSection />
            case (3):
                return <AboutContactSection />
            default :
                return <AboutMissionSection goToMethod={() => setSelectedTab(1)} />
        }
    }
}